/*
This js will build the app and is used for development
*/
import Vue from 'vue';
import App from '@/App.vue';
import moment from 'moment';
import '@/components/schreg-common/filters/phoneFilter.js';

// Create Life Time custom locale (but set back to default)
const current = moment.locale();
moment.locale('en-ltf', {
	monthsShort : [
		'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
	]
});
moment.locale(current);

Vue.config.productionTip = false;

const appElements = Array.from(document.querySelectorAll('.schedules-component-container'));

for (const el of appElements) {
	const uuid = Math.random().toString(16).substring(2);
	const appId = `schedules-component-app-${uuid}`;
	const elId = `schedules-component-element-${uuid}`;
	el.id = elId;
	if (el.firstElementChild) {
		el.firstElementChild.id = appId;
	}

	new Vue({ render: h => h(App) }).$mount('#'+appId);
}
